/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import {
    TableComponent
} from "../../../CommonComponents";
import "../../styles.scss";
import Heading from "../../../../../components/Heading";
import { ReportsService } from "../../../../../services/api/reports";
import { downloadCpOutscanClickableReport } from "../../../../../utils/downloadUtils";
import { useRequestCancellation } from "../../../../../hooks/useRequestCancellation";
import { useNavigate, useLocation } from "react-router-dom";
import { showErrorMessage } from "../../../../../utils";

const CpOutscanClickableReport = () => {
    // Global request cancellation hook
    const { createNewRequest, isLatestRequest } = useRequestCancellation();
    
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });
    const [reportData, setReportData] = useState([]);
    
    const [hubUser, setHubUser] = useState();
    
    const navigate = useNavigate();
    const location = useLocation();

    // Set user role
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userinfo"));
        setHubUser(user?.roles?.[0]);
    }, []);

    // Fetch report data
    useEffect(() => {
        if (!location.state) return;
        const { operationDate, bookingCpId, hubId } = location.state;
        if (!operationDate || !bookingCpId || !hubId) return;
        fetchReport();
        // eslint-disable-next-line
    }, [hubUser, location.state, pagination.current, pagination.pageSize]);

    const fetchReport = async () => {
        // 🔥 Create new request for cancellation support
        const requestId = createNewRequest();
        
        setLoading(true);
        let shouldUpdateState = true;
        
        try {
            // Get form parameters from location.state
            const formParams = location.state || {};
            const { operationDate, bookingCpId, hubId } = formParams;
            if (!operationDate || !bookingCpId || !hubId) {
                setLoading(false);
                return;
            }
            setReportData([]);
            // Format the date to YYYY-MM-DD format as required by API
            let formattedDate;
            formattedDate = moment(operationDate,"DD-MM-YYYY").format("YYYY-MM-DD");

            const params = {
                operationDate: formattedDate,
                bookingCpId: bookingCpId,
                hubId: hubId,
                page: (pagination.current - 1),
                size: pagination.pageSize
            };

            const { data, count } = await ReportsService.getCpOutscanClickableReport(params);
            
            // 🔥 Check if this is still the latest request
            if (!isLatestRequest(requestId.requestId)) {
                shouldUpdateState = false;
            } else {
                setReportData(data || []);
                setPagination(prev => ({
                    ...prev,
                    total: count || 0,
                }));
            }
        } catch (error) {
            
            if (shouldUpdateState && isLatestRequest(requestId.requestId)) {
                showErrorMessage(error);
                setReportData([]);
                setPagination(prev => ({
                    ...prev,
                    total: 0,
                }));
            }
        } finally {
            if (shouldUpdateState && isLatestRequest(requestId.requestId)) {
                setLoading(false);
            }
        }
    };

    const handleTableChange = (paginationInfo) => {
        setPagination(prev => ({
            ...prev,
            current: paginationInfo.current,
            pageSize: paginationInfo.pageSize
        }));
    };

    const handleDownload = async () => {
        setDownloadLoading(true);
        try {
            const formParams = location.state || {};
            const { operationDate, bookingCpId, hubId } = formParams;
            
            // Format the date to YYYY-MM-DD format for download
            let formattedDate;
            formattedDate = moment(operationDate,"DD-MM-YYYY").format("YYYY-MM-DD");
            const downloadParams = {
                operationDate: formattedDate,
                bookingCpId: bookingCpId,
                hubId: hubId
            };

            await downloadCpOutscanClickableReport(downloadParams);
            message.success("Report downloaded successfully");
        } catch (error) {
            console.error("Download error:", error);
            message.error("Failed to download report");
        } finally {
            setDownloadLoading(false);
        }
    };

    const handleBack = () => {
        navigate("/cp-outscan-vs-hub-inscan");
    };

    const getTableColumns = () => {
        return [
            {
                title: "No.",
                dataIndex: "index",
                key: "index",
                width: 60,
                render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
            },
            {
                title: "AWB Number",
                dataIndex: "awbNumber",
                key: "awbNumber",
                sorter: true,
                width: 150,
                render: (text, record) => (
                    <span
                        style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => {
                            const url = `/shipment-tracker?awb=${text}`;
                            window.open(url, "_blank");
                        }}
                    >
                        {text}
                    </span>
                )
            },
            {
                title: "Date",
                dataIndex: "date",
                key: "date",
                sorter: true,
                width: 120,
            },
            {
                title: "Booking CP Name",
                dataIndex: "bookingCpName",
                key: "bookingCpName",
                sorter: true,
                width: 200,
            },
            {
                title: "Hub Name",
                dataIndex: "hubName",
                key: "hubName",
                sorter: true,
                width: 200,
            },
        ];
    };

    return (
        <div className="report-container">
            <Heading 
                title="CP Outscan Report" 
                navigateTo="/cp-outscan-vs-hub-inscan"
                showBackButton={true}
                onBackClick={handleBack}
            />
            <Card className="report-card">
                <Row style={{ marginTop: 16 }}>
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            loading={downloadLoading}
                            onClick={handleDownload}
                        >
                            Download Report
                        </Button>
                    </Col>
                </Row>
            </Card>
            <TableComponent
                columns={getTableColumns()}
                dataSource={reportData}
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey={(record, index) => record.awbNumber || record.id || record.awb || index}
                style={{ marginTop: 32 }}
            />
        </div>
    );
};

export default CpOutscanClickableReport;
